export default "__VITE_ASSET__BPKqY6TK__"